import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-ng-for',
	templateUrl:'./NgForPluginCompPage.html',
	styles: [],
	styleUrls:['./NgForPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class NgForPluginCompPage
{
	mdContent_1079 = `\`\`\`java
import com.jwebmp.core.angular.components.NgFor;
\`\`\``;
	mdContent_1080 = `\`\`\`java
new NgFor()
\`\`\``;
}
